export default "__VITE_ASSET__$iLxGPqA__"